import { genSecret, isDev } from "src/utils"

const SERVER_HOST = `${window.location.protocol}//3d-gift.tliveapi.com`

// 通用 API 请求方法
async function makeApiRequest(params: {
  Action: string
  Payload?: Record<string, any>
}): Promise<any> {
  const { Action, Payload } = params
  const reqBody = {
    Action: params.Action,
    ProductName: "virtualman_manager",
    ...Payload,
  }
  const response = await fetch(
    `${SERVER_HOST}/api?Action=${Action}&${genSecret()}`,
    {
      method: "POST",
      // headers: {
      //   携带Content-Type会导致预检请求，后端没实现
      //   "Content-Type": "application/json",
      // },
      body: JSON.stringify(reqBody),
    },
  )

  if (!response.ok) {
    throw new Error(`API request failed: ${response.statusText}`)
  }
  const data = await response.json()

  if (isDev()) {
    console.log("[API] ", reqBody, data)
  }

  return data
}

/**
 * 获取默认配置+预设
 */
export async function getEffectsPresetApi(): Promise<PresetConfig> {
  const rsp = await makeApiRequest({
    Action: "DescribeAnimationEffect",
  })
  const data = rsp.Response

  const preset_effects: PresetConfig["EffectPreset"] = []
  data.default_3d_gift_flag.forEach((item: any) => {
    preset_effects.push({
      id: item.id,
      name: item.name,
      previewImg: item.pic_url,
    })
  })

  const result: PresetConfig = {
    EffectPreset: preset_effects,
    PromptPreset: data.default_3d_gift_prompt,
    PlayAddrPreset: data.default_play_addr,
  }
  return result
}

/**
 * 包装拉流地址
 */
export async function wrapPlayUrlApi(params: {
  play_url: string
}): Promise<string> {
  const rsp = await makeApiRequest({
    Action: "StartPullSourceStream",
    Payload: {
      SourceUrl: params.play_url,
    },
  })
  return rsp.Response.PlayAddr
}

/**
 * 检查是否允许发送
 */
export async function CheckPromptAiailableApi() {
  const rsp = await makeApiRequest({
    Action: "DescribeText2VideoStatus",
  })
  return !!rsp.Response.IsEnableSend
}

/**
 * 获取发送历史
 */
export async function getSendHistoryApi(arg: {
  /**
   * 关键词检索
   */
  GiftPrompt?: string
}): Promise<SendHistoryItem[]> {
  const rsp = await makeApiRequest({
    Action: "DescribeHistoryGift",
    Payload: {
      GiftPrompt: arg.GiftPrompt,
    },
  })

  const data = rsp.Response.GiftList
  const result: SendHistoryItem[] = []
  data.forEach((item: any) => {
    result.push({
      GiftId: item.GiftId,
      GiftVideoUrl: item.GiftVideoUrl,
      PromptText: item.Prompt,
      Score: item.Score,
    })
  })
  console.log("DescribeHistoryGift: ", result)
  return result
}

/**
 * 查询生成队列
 */
export async function getGenQueueApi(): Promise<TaskInfo> {
  const rsp = await makeApiRequest({
    Action: "DescribeText2VideoStatus",
  })

  const data = rsp.Response
  const result: TaskInfo = {
    IsEnableSend: data.IsEnableSend,
    Msg: data.Msg,
    QueuePromptList: data.QueuePromptList,
  }

  if (isDev()) {
    result.QueuePromptList.push("测试用例1")
    result.QueuePromptList.push("测试用例2")
    result.QueuePromptList.push("测试用例3")
  }

  return result
}

/**
 * 发送礼物接口
 *
 * 优先带视频地址的，也就是那些预制的，如果用户直接点击了历史prompt，可以直接携带对应giftid过来，最后是输入prompt的
 */
export async function sendGiftApi(arg: {
  /**
   * 生成提示
   */
  GiftPrompt?: string
  /**
   * 预设礼物id
   */
  PreMadeGiftId?: string
  /**
   * 播放地址
   */
  InnerPlayAddr: string
}): Promise<void> {
  if (!arg.InnerPlayAddr) {
    throw new Error("InnerPlayAddr is required")
  }

  if (!arg.GiftPrompt && !arg.PreMadeGiftId) {
    throw new Error("GiftPrompt or PreMadeGiftId is required")
  }

  await makeApiRequest({
    Action: "SendAnimationEffectGift",
    Payload: {
      GiftPrompt: arg.GiftPrompt,
      InnerPlayAddr: arg.InnerPlayAddr,
      PreMadeGiftId: arg.PreMadeGiftId,
    },
  })
}
